import { createFileRoute } from "@tanstack/react-router";
import { submissionSearchSchema } from "./-components/submission-search";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { useSubmissionLabels } from "~/hooks/useSubmissionLabels";
import { JobSubmissionsTable } from "./-pages/job-submissions-table";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/job-submissions/")({
  validateSearch: submissionSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  const submissionTerm = useSubmissionLabels();
  useBreadCrumbs([{ title: submissionTerm.plural, link: `/${datasetSlug}/data/job-submissions` }]);
  return <JobSubmissionsTable />;
}
